// Add .no-right-part to .text-with-stats if .stat is missing
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.text-with-stats').forEach(function(section) {
    if (!section.querySelector('.stat')) {
      section.classList.add('no-right-part');
    }
  });
});


// Set stop-counter values immediately to avoid showing 0
function initStopCounters() {
  const sections = document.querySelectorAll(".stats.stop-counter");

  sections.forEach((section) => {
    const counters = section.querySelectorAll(".counter[data-target], .count-wrap[data-target]")

    counters.forEach((counter) => {

      // SAFE TARGET VALUE
      const targetAttr = counter.getAttribute("data-target") || "0";
      const target = parseFloat(targetAttr);

      const prefix = counter.getAttribute("data-prefix") || "";
      const suffix = counter.getAttribute("data-suffix") || "";

      const decimals = targetAttr.includes(".") ? 2 : 0;

      counter.textContent =
        prefix + target.toFixed(decimals) + suffix;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStopCounters);
} else {
  initStopCounters();
}

window.addEventListener("load", function () {

  const sections = document.querySelectorAll(".stats");
  const duration = 4000;

  // Function to set widths for .stats.text-counter-aligned
  function setWidths() {
    const section = document.querySelector(".stats.text-counter-aligned");

    if (section) {
      const textWraps = section.querySelectorAll(".text-wrap");

      textWraps.forEach((wrap) => {
        const h2 = wrap.querySelector("h2.h1.count-wrap");
        const h4 = wrap.querySelector("h4");

        if (h2 && h4) {

          h2.style.width = "";
          h4.style.width = "";

          const parentWidth = wrap.clientWidth;
          const h2Width = h2.offsetWidth;
          const remaining = parentWidth - h2Width;

          h2.style.width = h2Width + "px";
          h4.style.width =
            remaining > 0 ? remaining + "px" : "auto";
        }
      });
    }
  }

  // Run width setup after layout stabilizes
  const runSetWidths = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // setWidths();
      });
    });
  };

  // Wait for fonts if available
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      runSetWidths();
    });
  } else {
    runSetWidths();
  }

  // === COUNTER LOGIC ===
  sections.forEach((section) => {

    const cols = section.querySelectorAll(".col-three");

    if (cols.length > 1 && cols.length < 3) {
      section.classList.add("two-wrapper");
    }

    // Stop counter logic
    if (section.classList.contains("stop-counter")) {

      const counters = section.querySelectorAll(".counter[data-target], .count-wrap[data-target]")

      counters.forEach((counter) => {

        // SAFE TARGET VALUE
        const targetAttr =
          counter.getAttribute("data-target") || "0";

        const target = parseFloat(targetAttr);

        const prefix =
          counter.getAttribute("data-prefix") || "";

        const suffix =
          counter.getAttribute("data-suffix") || "";

        const decimals =
          targetAttr.includes(".") ? 2 : 0;

        counter.textContent =
          prefix + target.toFixed(decimals) + suffix;
      });
    }
  });

  // Function to animate counters
  const runCounters = (section) => {

    // Skip stop-counter
    if (section.classList.contains("stop-counter")) {
      return;
    }

    const counters =
      section.querySelectorAll(".counter[data-target], .count-wrap[data-target]")

    counters.forEach((counter) => {

      const start =
        parseFloat(counter.getAttribute("data-start")) || 0;

      // SAFE TARGET VALUE
      const targetAttr =
        counter.getAttribute("data-target") || "0";

      const target = parseFloat(targetAttr);

      const prefix =
        counter.getAttribute("data-prefix") || "";

      const suffix =
        counter.getAttribute("data-suffix") || "";

      const decimals =
        targetAttr.includes(".") ? 2 : 0;

      // DEBUG
      if (!counter.getAttribute("data-target")) {
        console.log("Missing data-target:", counter);
      }

      if (counter.classList.contains("stop-counter")) {
        counter.textContent =
          prefix + target.toFixed(decimals) + suffix;
        return;
      }

      counter.textContent =
        prefix + start.toFixed(decimals) + suffix;

      const startTime = performance.now();

      const animate = (now) => {

        const elapsed = now - startTime;

        const progress =
          Math.min(elapsed / duration, 1);

        const value =
          (start + (target - start) * progress)
          .toFixed(decimals);

        counter.textContent =
          prefix + value + suffix;

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          counter.textContent =
            prefix + target.toFixed(decimals) + suffix;
        }
      };

      requestAnimationFrame(animate);
    });
  };

  // Intersection Observer
  const observer = new IntersectionObserver(
    (entries, obs) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          // setWidths();

          runCounters(entry.target);

          obs.unobserve(entry.target);
        }
      });

    },
    {
      threshold: 0.5
    }
  );

  // Observe sections
  sections.forEach((section) => {

    if (!section.classList.contains("stop-counter")) {

      observer.observe(section);

    } else {

      // setWidths();
    }
  });

});